import {useCallback, useState} from 'react';

import type {SavedSettingToastState} from '../../saved-setting-toast/saved-setting-toast';

export function useValueSaveToastTracker(): {
    valueSaveToastState: SavedSettingToastState;
    setValueSaveToastState: (state: SavedSettingToastState) => void;
    trackValueSaveToastForPromise: (promise: Promise<any>) => Promise<any>;
} {
    const [valueSaveToastState, setValueSaveToastState] =
        useState<SavedSettingToastState>('initial');

    const trackValueSaveToastForPromise = useCallback((promise: Promise<any>) => {
        setValueSaveToastState('saving');
        return promise
            .then((result) => {
                setValueSaveToastState('complete');
                return result;
            })
            .catch((error) => {
                setValueSaveToastState('initial');
                throw error;
            });
    }, []);

    return {
        valueSaveToastState,
        setValueSaveToastState,
        trackValueSaveToastForPromise,
    };
}
